import { render, staticRenderFns } from "./ProfileSuggestion.vue?vue&type=template&id=212541d2&"
import script from "./ProfileSuggestion.vue?vue&type=script&lang=js&"
export * from "./ProfileSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212541d2')) {
      api.createRecord('212541d2', component.options)
    } else {
      api.reload('212541d2', component.options)
    }
    module.hot.accept("./ProfileSuggestion.vue?vue&type=template&id=212541d2&", function () {
      api.rerender('212541d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/profile/ProfileSuggestion.vue"
export default component.exports